import React, { createContext, useContext, useState, useEffect } from 'react';
import { matrimonyApi } from './matrimonyApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]                   = useState(undefined); // undefined = loading
  const [profile, setProfile]             = useState({});
  const [isAdmin, setIsAdmin]             = useState(false);
  const [adminName, setAdminName]         = useState('');
  const [adminViaSmabizz, setAdminViaSmabizz] = useState(false);

  function applyData(data) {
    setUser(data.user && data.user.id ? data.user : null);
    setProfile(data.profile || {});
    setIsAdmin(!!data.admin);
    setAdminName(data.adminName || (data.user && data.user.name) || '');
    setAdminViaSmabizz(!!data.adminViaSmabizz);
  }

  useEffect(() => {
    matrimonyApi.getMe().then(applyData).catch(() => { setUser(null); setIsAdmin(false); });
  }, []);

  const refresh = () =>
    matrimonyApi.getMe().then(applyData).catch(() => { setUser(null); setIsAdmin(false); });

  const logout = async () => {
    await matrimonyApi.logout().catch(() => {});
    setUser(null); setProfile({}); setIsAdmin(false); setAdminName(''); setAdminViaSmabizz(false);
  };

  return (
    <AuthContext.Provider value={{ user, profile, isAdmin, adminName, adminViaSmabizz, refresh, logout, setProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
